module.exports = __webpack_public_path__ + "img/logo.583a8dd1.svg";